<template>
  <div>
    <a id="thanks-form" ref="thanksForm"></a>
    <template v-if="loading">
      <slot>
        <loader />
      </slot>
    </template>
    <load-error v-if="!loading && loadFailed" class="my-10" message="We couldn't load your booking. Check your connection and try again." @retry="loadBooking" />
    <thanks v-if="!loading && !loadFailed"></thanks>
  </div>
</template>
<script>
import "./helpers/form-setup"
import Loader from "./components/Loader.vue";
import LoadError from "../checkout/components/LoadError.vue";
import { reportLoadError } from "../helpers/network";
import { Thanks } from "./routes"
import useStore from "./store"

export default {
  name: 'BookThanks',
  components: {
    Loader,
    LoadError,
    Thanks
  },
  props: {
    booking: {
      type: [String, Boolean],
      default: false,
    },
    token: {
      type: [String, Number, Boolean],
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      loadFailed: false,
    };
  },
  methods: {
    setLoading(loading) {
      this.loading = loading;
    },
    top(){
      this.$refs.bookingForm.scrollIntoView({
        behavior: 'smooth',
      });
    },
    async loadBooking() {
      const store = useStore();

      if (!this.booking){
        return;
      }

      if (!this.token){
        return;
      }

      this.loading = true;
      this.loadFailed = false;

      try {
        await store.loadOptions();
        await store.loadAttractions();
        await store.loadBooking(this.booking, this.token);
      } catch (error) {
        this.loadFailed = true;
        reportLoadError(error);
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.loading = true;

    console.log('MOUNTED');

    this.loadBooking();

    this.$events.$on("loading", this.setLoading);
  },
  beforeUnmount() {
    this.$events.$off("loading", this.setLoading);
  },
};
</script>
